import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

const WAVEFORM_BAR_COUNT = 3;
const BAR_DELAY_MS = 150;

const barBounce = keyframes`
  0%, 100% { transform: scaleY(0.35); }
  50% { transform: scaleY(1); }
`;

export default function DictationWaveform() {
  return (
    <Box
      aria-hidden
      data-test-id="tread-agent-dictation-waveform"
      sx={{ alignItems: 'center', display: 'flex', gap: '2.5px', height: 14 }}
    >
      {Array.from({ length: WAVEFORM_BAR_COUNT }, (_, index) => (
        <Box
          data-test-id="tread-agent-dictation-waveform-bar"
          key={index}
          sx={{
            animation: `${barBounce} 900ms ease-in-out ${index * BAR_DELAY_MS}ms infinite`,
            bgcolor: 'currentColor',
            borderRadius: '999px',
            height: '100%',
            width: '2.5px',
            '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
          }}
        />
      ))}
    </Box>
  );
}
